import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { InputOTP } from "antd-input-otp";
import { useNavigate } from "react-router";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../../App.css";
import {
  SendOTP,
  ResetPassword,
} from "../../Api/ForgotPassword/ForgotPassword";
import { toast } from "react-toastify";
import "../../App.css";
import { message, Spin } from "antd";

const emailDomains = ['gmail.com', 'outlook.com'];




const ProductOwnerForgotPassword = ({
  setLoginHide,
  setShowComponent,
  setForgotPassword,
  typeID
}) => {
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const navigation = useNavigate();
  const [value, setValue] = useState([]);
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [showPassword, setShowPassword] = useState(false);
  const [storeMail,setStoreMail] = useState("")
  const [spinning,setSpinning] = useState(false)
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const [userError,setUserError] = useState(false)
  const [fetchOtp,setFetchOtp]=useState();

  // const[inputNewPassword, setInputNewPassword] = useState("") -------------------------------------------------------------------
  // const[inputConfirmPassword, setInputConfirmPassword] = useState("")
  const[correctOtp, setCorrectOtp] = useState("")
  const [error, setError] = useState('');
  // const [userOtp,setUserOtp]=useState();
  const[userOtpError,setUserOtpError]=useState(false);






  const validationSchema = Yup.object().shape({
  email_id: Yup.string()

    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address format"
    )
    
    .required("Email is required"),
    

});

const handleClick=async()=>{
if(<ErrorMessage/>){
setUserError(false)
}else{
  setUserError(true)
}
}


  const handleSendOTP = async (values) => {
    console.log(values ,typeID, "values emailid");
    // setOtpEnabled(true);
    setSpinning(true)
    try {
      const otpMail = values.email_id;
      setStoreMail(otpMail)
      const response = await SendOTP(otpMail,typeID,setSpinning);
      console.log(response.request.status," otp response 2")
      console.log(response," otp")
    //   setFetchOtp((prevState) => ({
    //       ...prevState,
    //       otpdata:response.data.message.otp
    //   })
    // )
    console.log("OTP Data",fetchOtp)
      if(response.request.status === 200) {
        setOtpEnabled(true);
      } else {
        setUserError(true)
      }
      console.log(response, "-----response emailid");
      // toast.success(response?.data?.message); ---------------------------------------------------------------------------------------
      setCorrectOtp(response.data.otp)
    } catch (error) {
      console.error("Error sending OTP", error);
    }
  };
  console.log("OOOOOOTP",correctOtp)

  const handleResendOTP = async() => {
    console.log("Resending OTP...");
    try {
      const response = await SendOTP(storeMail,typeID,setSpinning);
      setOtpEnabled(true);
      console.log(response, "-----response emailid");
      // toast.success(response?.data?.message);
    } catch (error) {
      console.error("Error sending OTP", error);
    }
  };
  const handleSubmit = async (values) => {
     console.log(values ,typeID, "values");
    try {
      setSpinning(true)
      const response = await ResetPassword(values ,typeID,setSpinning);
      setForgotPassword(false)
      setLoginHide(true);
      setShowComponent(false);
      // navigation("/");
      // toast.success(response?.data?.message); -------------------------------------------------------------------------------------
      console.log(response, "response")
      const allEmpty = otpDigits.every(digit => digit === "");
      if(allEmpty) {
        setError("OTP is required")
      } else {
        setError("OTP is invalid")
      }  
      
    } catch (error) {
      console.error("Error resetting password", error);
      const allEmpty = otpDigits.every(digit => digit === ""); //----------------------------------------------------------------
      if(allEmpty) {
        setError("OTP is required")
      } else {
        setError("OTP is incorrect")
      } 
      // if(values.otp){
      //   toast.error("Invalid OTP")
      // }
      // console.log(values, "error values") //---------------------------------------------------------------------------------------
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setshowConfirmPassword(!showConfirmPassword);
  };
  console.log(otpEnabled, "otpEnabled");


  const validationFullSchema = Yup.object().shape({
  email_id: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address format"
    )
    .required("Email is required"),
  // otp: Yup.string().required("OTP is required"),
  newPassword: Yup.string().required("New password is required"),
  confirm: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Please confirm your password"),
});




// const handleOtp=async()=>{
// if(correctOtp===otpDigits){
//  setUserError(false)
// }else {
//   setUserError(true);
// }
// }
  
  return (
    <div className="absolute right-0 top-0 bg-[#E5FFF1] h-full w-[70vw] md:w-[38vw] rounded-tr-[2vw] rounded-br-[2vw] bg-opacity-80 flex flex-col items-center justify-center">
       {spinning === true ? (
              <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-5  z-30">
                <Spin size="large" />
              </div>
            ) : "" }
      <label className="text-[#1F487C] font-bold text-[5vw] md:text-[2vw] ">
        {otpEnabled ? "Create New Password" : "Forgot Password"}
      </label>
      <Formik
        initialValues={{
          email_id: "",
          otp: "",
          newPassword: "",
          confirm: "",
        }}
        validationSchema={() => {
          return !otpEnabled ? validationSchema : validationFullSchema;
        }}
        onSubmit={(values, { setSubmitting }) => {
          console.log(values,"iufhdxkjfhkjdhfkjdhf");          
          if (!otpEnabled) {
            handleSendOTP(values);
          } else {
            values.otp = otpDigits.join("");
            handleSubmit(values);
          }
        }}
      >
        {({values,handleSubmit}) => (
          <Form onSubmit={handleSubmit}>
            <div className="gap-y-[1.5vw] flex-col flex pt-[1vw]">
              {otpEnabled ? (
                <>
                  <div className="col-span-1 relative px-[2vw] md:px-0">
                    <InputOTP
                      name="otp"
                      id="otp"
                      style={{
                        borderColor: "#1f4b7f",
                        // width: "10vw",
                        // height: "2vw !important",
                      }}
                      inputClassName="w-full input-otp__field p-0"
                      numInputs={6}
                      onChange={(otpValue) => {
                        const updatedDigits = [...otpDigits];
                        for (let i = 0; i < otpValue.length; i++) {
                          if (otpValue[i]) {
                            updatedDigits[i] = otpValue[i];
                          }
                        }
                        setOtpDigits(updatedDigits);
                        // setError(validateOtp([otpValue]));
                        console.log(otpDigits, "otp digits")
                        console.log("OTP Value",updatedDigits)
                      }}
                      // wrapperStyle={{
                      //   height: "0.5vw",
                      // }}
                      classNames="input-otp__field"
                      inputType="numeric"
                      // onClick={handleOtp}
                      
                    />
               


                      <ErrorMessage
                      name="otp"
                      component="div"
                      className="text-red-500 text-[2vw] md:text-[0.8vw] absolute bottom-[-3vw] md:bottom-[-1.2vw] ml-[0.5vw] mt-[0.6vw] font-semibold md:font-normal"
                    />
                    {/* {userOtpError && <div
                      className="text-red-500 text-[0.8vw] absolute ml-[0.4vw] "
                    >Invalid OTP</div>} */}
                    {/* <Field ---------------------------------------------------------------------------------------------------
                    type='text'
                    name='otp'
                    placeholder="Enter otp"
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1.1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                        />
                    <ErrorMessage
                      name="otp"
                      component="div"
                      className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                    /> */}
                    {error?<div
                      className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]">Invalid OTP</div>:""}
                  </div>
                  <div className="pt-[1vw] md:pt-0 px-[2vw] md:px-0">
                      <button
                    type="button"
                    onClick={handleResendOTP}
                    className="w-full flex justify-center py-2 px-2 border border-transparent rounded-md shadow-sm text-[3vw] md:text-[1vw] font-medium text-white bg-[#1F487C]"
                  >
                    Resend OTP
                  </button>
                  </div>
                  
                  <div className="col-span-1 relative px-[2vw] md:px-0">
                    <div className="relative flex items-center">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="newPassword"
                        placeholder="Enter New Password"
                        // onChange={(e) => setInputNewPassword(e.target.value)} 
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[3vw] md:text-[1.1vw] h-[7.5vw] md:h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                        />
                      <div
                        className="absolute right-[1vw] cursor-pointer"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <FaEye className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                        ) : (
                          <FaEyeSlash className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                        )}
                      </div>
                    </div>

                    <ErrorMessage
                      name="newPassword"
                      component="div"
                      className="text-red-500 text-[2vw] md:text-[0.8vw] absolute bottom-[-3vw] md:bottom-[-1.2vw] ml-[0.5vw] font-semibold md:font-normal"
                    />
                  </div>
                  <div className="col-span-1 relative px-[2vw] md:px-0">
                    <div className="relative flex items-center">
                      <Field
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirm"
                        placeholder="Enter Confirm Password"
                        // onChange={(e) => setInputConfirmPassword(e.target.value)} 
                        className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[3vw] md:text-[1.1vw] h-[7.5vw] md:h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                      />
                      <div
                        className="absolute right-[1vw] cursor-pointer"
                        onClick={toggleConfirmPassword}
                      >
                        {showConfirmPassword ? (
                          <FaEye className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                        ) : (
                          <FaEyeSlash className="text-[3.5vw] md:text-[1.5vw] text-[#1F487C]" />
                        )}
                      </div>
                    </div>

                    <ErrorMessage
                      name="confirm"
                      component="div"
                      className="text-red-500 text-[2vw] md:text-[0.8vw] absolute bottom-[-3vw] md:bottom-[-1.2vw] ml-[0.5vw] font-semibold md:font-normal"
                    />
                  </div>
                  <div className="pt-[1vw] px-[2vw] md:px-0">
                    <button
                      onClick={handleSubmit}
                      type="submit"
                      //disabled={isSubmitting}
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-[3vw] md:text-[1.2vw] font-medium text-white bg-[#1F487C]"
                    >
                      Submit
                    </button>
                  </div>
                  <p
                    className="text-[3vw] md:text-[1vw] text-center font-semibold text-[#1F487C] cursor-pointer"
                    onClick={() => {setOtpEnabled(false)
                      setError("")
                      setUserError(false);
                      setUserOtpError(false);
                      // setInputNewPassword("") -------------------------------------------------------------------------------
                    // setInputConfirmPassword("")
                  }
                    }
                  >
                    Back
                  </p>
                </>
              ) : (
                <>
                  <div className="col-span-1 relative">
                    <label className="text-[#1F487C] text-[3vw] md:text-[1.3vw] ">
                      Email ID
                      <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                        *
                      </span>
                    </label>
                    <Field
                      type="text"
                      name="email_id"
                      placeholder="Enter Email Address"
                       className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[3vw] md:text-[1vw] h-[7.5vw] md:h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]" 
                      
                     onClick={handleClick}
                    /> 
                    
                    
                    <ErrorMessage
                      name="email_id"
                      component="div"
                      className="text-red-500 text-[2vw] md:text-[0.8vw] absolute ml-[0.4vw] font-semibold md:font-normal"
                    />
                    {userError && <div
                      className="text-red-500 text-[2vw] md:text-[0.8vw] absolute ml-[0.4vw] font-semibold md:font-normal"
                    >User not found</div>}
                    
                    
                  </div>
                  <div className="flex justify-center mt-[2vw] md:mt-0">
                    {!otpEnabled ? (
                      <button
                        type="submit"
                        
                        
                      
                      className="w-full flex justify-center py-[1vw] md:py-[0.5vw] px-2 border border-transparent rounded-md shadow-sm text-[3vw] md:text-[1vw] font-medium text-white bg-[#1F487C]"
                      >
                        Send OTP
                      </button>
                    ) : (
                      <button
                        type="button"
                        // onClick={handleResendOTP}
                        className="w-full flex justify-center py-[1vw] md:py-[0.5vw] px-2 border border-transparent rounded-md shadow-sm text-[3vw] md:text-[1vw] font-medium text-white bg-[#1F487C]"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                  <p
                    className="text-[3vw] md:text-[1vw] text-center font-semibold text-[#1F487C] cursor-pointer"
                    onClick={() => setForgotPassword(false)}
                  >
                    Back
                  </p>
                </>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ProductOwnerForgotPassword;
